/* eslint-disable no-template-curly-in-string */
import { setLocale } from 'yup';

setLocale({
  mixed: {
    required: 'Please fill out this required field.',
    min: 'Must be at least ${min} characters.',
    max: 'Must be at most ${max} characters.',
    email: 'Please enter a valid email address.',
  },
  string: {
    required: 'Please fill out this required field.',
    min: 'Must be at least ${min} characters.',
    max: 'Must be at most ${max} characters.',
    email: 'Please enter a valid email address.',
  },
});
